import dayjs from 'dayjs'
import { EventDoc } from 'types/api/changes'

export function isEventMoreThanADay(event: EventDoc) {
  if (!event.StartDate || !event.EndDate) return false

  return (
    dayjs
      .unix(Number(event.EndDate))
      .diff(dayjs.unix(Number(event.StartDate)), 'day') > 0
  )
}
